;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputCheckbox', inputCheckbox)

  /* @ngInject */
  function inputCheckbox () {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        description: '@',
        inputId: '@',
        modelPropertyName: '@',
        model: '=',
        value: '<',
        disabled: '<',
        mandatory: '<',
        toggle: '<',
        change: '&',
        clickText: '<',
        pricing: '<',
        pricingTooltip: '<',
        pricingTooltipPosition: '<',
        pricingData: '<',
        titleTooltip: '@'
      },
      templateUrl: '/core/directives/input-checkbox/input-checkbox-directive.html?$$REVISION$$',
      controller: 'InputCheckboxController'
    }
  }
})()
